// vuex是存储在内存中的
// 刷新页面会导致state丢失
// 可以把state存储在cookie或者storage里
// 初始化state的时候去本地拿
// set : localStorage.name=value   get: localStorage.name
// sessionStorage  同理
import Vue from 'vue';
import Vuex from 'vuex';

import user from './user';
import settings from './settings';

import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    settings
  },
  getters
});
